import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CommunityRedirect = () => {
  const location = useLocation();
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /android/i.test(userAgent);

    const path = location.pathname + location.search; // /c/67e5a50f.../share?type=xxx
    let appSchemeURL = `cerkle://${path}`;

    if(isIOS){
        appSchemeURL = `cerkle://${path}`
    }

    let fallbackURL = 'https://vybecerkle.com'; // If neither iOS nor Android

    if (isIOS) {
      fallbackURL = 'https://apps.apple.com/in/app/cerkle/id6749543299';
    } else if (isAndroid) {
      fallbackURL = 'https://play.google.com/store/apps/details?id=com.vybecerkle.cerkle';
    }

    // Try to open app
    window.location.href = appSchemeURL;

    // Fallback after 2s
    setTimeout(() => {
      window.location.href = fallbackURL;
    }, 10000);
  }, [location]);

  return (
    <div>
      <h5>Opening App... If nothing happens, you will be redirected to the store in 10 seconds.</h5>
    </div>
  );
};

export default CommunityRedirect;
